module.exports = __webpack_public_path__ + "static/media/address-a.7f9a139e.svg";